import React from "react";
import clsx from "clsx";
import { fixedDateOptions } from "../../helper";

interface Props {
  activeKey: string | null;
  onSelect: (key: string) => void;
  setActiveKey: (key: string | null) => void;
}

export const FixedDateOptionsList: React.FC<Props> = ({ activeKey, onSelect }) => (
  <div className="flex flex-col gap-1 bg-gray-400 w-[250px]">
    {fixedDateOptions.map(({ key, label }) => (
      <button
        key={key}
        onClick={() => onSelect(key)}
        className={clsx(
          "w-full text-left px-4 h-[31px] text-[11px] transition",
          activeKey === key
            ? "bg-[#EFF4FE] text-primary border border-gray-100"
            : "text-black hover:bg-gray-200"
        )}
      >
        {label}
      </button>
    ))}
  </div>
);
